import API from "@/models/API";

export default class SupplierManagement {
    constructor(item = {}) {
        this.supplier_name = item.supplier_name || "";
        this.supplier_primary_phone = item.supplier_primary_phone || "";
        this.supplier_email_1 = item.supplier_email_1 || "";
        this.supplier_email_2 = item.supplier_email_2 || "";
        this.supplier_country_id = item.supplier_country_id || null;
        this.user_mobile = item.user_mobile || "";
        this.user_country_id = item.user_country_id || null;
        this.user_full_name = item.user_full_name || "";
        this.user_email_1 = item.user_email_1 || "";
        this.user_email_2 = item.user_email_2 || "";
        this.user_gender = item.user_gender || "";
    }

    static get = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/suppliers`);

    static getCountries = () =>
        API.get(`/common/countries`);

    static getMessage = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/suppliers/notification/message`);

    static updateMessage = body =>
        API.put(
            `/companies/${localStorage.getItem("storeId")}/suppliers/notification/message`,
            body
        );

    static create = body =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/suppliers`,
            body
        );

    static delete = id =>
        API.delete(
            `/companies/${localStorage.getItem("storeId")}/suppliers/${id}`
        );
}
